"use client";

import { LavenderCarpetSectionProps } from "@/services/home/types";
import Video from "./video";
import { Shell } from "@/components/ui/shell";

type Props = {
  data: LavenderCarpetSectionProps;
};

export default function LavenderCarpet({ data }: Readonly<Props>) {
  if (!data) return null;

  return (
    <div className="flex w-full flex-col gap-4">
      <Shell className="overflow-hidden">
        <div className="w-full">
          <h1 className="text-3xl text-secondary sm:text-4xl sm:text-[38px] xl:text-[48px] ltr:font-playfair">
            {data?.title}
          </h1>
        </div>
      </Shell>
      <Video src={data?.video_link ?? ""} type="video/mp4" />
    </div>
  );
}
